import { authHeader } from "../../../../../helpers/auth-header";
import { client } from "../../../../../actions";
import uri from "../../../constants/uri";

const createVoting = async (voting) => {
	return await client.post(uri, voting, {
		headers: authHeader(),
	});
};

export default createVoting;
